import { createAction } from 'redux-actions';

const MODULE = 'app/nav';

const TOGGLE_NAV = `${MODULE}/TOGGLE_NAV`;

export const toggleNav = createAction(TOGGLE_NAV);
